export default {
  title: '报表',
  tab: '报表',
  label: {
    userName: '用户名称',
    resumeViewedCount: '简历浏览量（菁客）',
    widgetResumeViewedCount: '简历浏览量（{channel}）',
    incomingResumeCount: '入库简历数',
    referralResumeCount: '推荐简历数',
    interviewResumeCount: '面试简历数',
    offeredResumeCount: 'Offer 简历数',
    userUsageDuration: '用户使用时长',
    activeDays: '活跃天数',
    companyName: '公司名称',
    startDate: '开始日期',
    endDate: '结束日期',
    selectHr: '请选择招聘人员',
    selectAllHr: '全部',
    last7Days: '最近 7 天',
    last30Days: '最近 30 天',
    last90Days: '最近 90 天',
    hour: '{hour}小时',
    minute: '{minute}分'
  },
  btn: {
    export: '导出',
    save: '保存',
    checkAll: '全选'
  },
  message: {
    deleteFilterContent: '确认从分组中移除此用户？',
    deleteFilterTitle: '提示',
    deleteSearchGroupSuccess: '删除成功',
    cancelDeleteSearchGroup: '已取消',
    saveGroupTitle: '保存分组',
    saveGroupTip: '另存为新的分组或更新已存在的分组',
    saveGroupContent: '保存新分组',
    updateGroupContent: '更新已存在的分组',
    saveGroupSuccess: '保存成功',
    dateRangeTooLong: '日期范围最大选取90天'
  },
  companyExport: {
    title: '导出数据',
    menu: '导出数据'
  },
  exportApplyData: {
    title: '导出申请数据',
    menu: '导出申请数据'
  },
  hiringFunnelReport: {
    title: '招聘阶段情况报表',
    menu: '招聘阶段情况报表'
  },
  sourcingChannelReport: {
    title: '来源渠道报表',
    menu: '来源渠道报表'
  },
  customReferralReport: {
    title: '推荐余额报表',
    menu: '推荐余额报表'
  },
  userUsageReport: {
    title: '用户使用概况报表',
    menu: '用户使用概况报表'
  },
  potentialCandidateReport: {
    title: '潜在候选人报表',
    menu: '潜在候选人报表'
  },
  satisfactionSurveyHiringManagerReport: {
    title: '满意度调查报表 - 招聘经理',
    menu: '满意度调查报表 - 招聘经理'
  },
  satisfactionSurveyCandidateReport: {
    title: '满意度调查报表 - 求职者',
    menu: '满意度调查报表 - 求职者'
  },
  wechatTemplateMessageReportTotal: {
    title: '微信模板报表 - 整体',
    menu: '微信模板报表 - 整体'
  },
  wechatTemplateMessageReportDetail: {
    title: '微信模板报表 - 详细情况',
    menu: '微信模板报表 - 详细情况'
  },
  recruiterKpiDashboard: {
    title: '招聘人员KPI仪表盘',
    menu: '招聘人员KPI仪表盘'
  }
}
